import { announcements, announcementInit } from './announcements';
// import { mobileMenuInit } from './mobileMenu';
import cartCount from './cartCount';
import headroomInit from './headroomInit';

let mobile_menu_open = false;

export default function () {
  cartCount();

  document.addEventListener('shopify:section:load', (e) => {
    if (e.detail.sectionId !== 'INF-Header') {
      return;
    }

    // Reinit mobile menu & headroom
    // mobileMenuInit();
    headroomInit();

    // If the mobile menu was open previously, reopen it
    if (mobile_menu_open) {
      document.querySelector('[data-state]').classList.add('State--mobile-menu-open');
    }

    document.querySelectorAll('[data-announcements-carousel]').forEach((carousel) => {
      const id = carousel.parentElement.id;
      let index = 0;

      // Has this carousel already been initialized? Destroy it if so...
      // (this was `announcements[id] > 0`, which never matched an object, so
      // teardown was silently skipped and instances leaked on every re-init)
      if (announcements[id]) {
        // Save the current slide's index so we can immediately reinitialize at the same slide later
        index = announcements[id].selectedIndex;
        // Destroy the existing one since it exists
        announcements[id].destroy();
        delete announcements[id];
      }

      // Reinitialize the carousel with new options
      announcementInit(carousel, index);
    });
  });

  document.addEventListener('shopify:section:unload', (e) => {
    if (e.detail.sectionId !== 'INF-Header') {
      return;
    }

    mobile_menu_open = false;

    if (document.querySelector('[data-state]').classList.contains('State--mobile-menu-open')) {
      mobile_menu_open = true;
    }
  });

  document.addEventListener('shopify:block:select', (e) => {
    if (e.detail.sectionId !== 'INF-Header') {
      return;
    }

    // Navigate to the correct slide and pause autoplay
    const block_id = e.detail.blockId;
    const blockElement = document.querySelector(`[data-block-${block_id}]`);
    if (!blockElement) return;
    // Skip clones — they are duplicates injected around the real slides, so a
    // raw indexOf() would be off by one.
    const realSlides = Array.from(blockElement.parentElement.children).filter(
      (child) => !child.hasAttribute('data-clone'),
    );
    const index = realSlides.indexOf(blockElement);

    document.querySelectorAll('[data-announcements-carousel]').forEach((carousel) => {
      const id = carousel.parentElement.id;
      if (!announcements[id]) return;
      announcements[id].select(index);
      announcements[id].pausePlayer();
    });
  });

  document.addEventListener('shopify:block:deselect', (e) => {
    if (e.detail.sectionId !== 'INF-Header') {
      return;
    }

    // Unpause autoplay
    document.querySelectorAll('[data-announcements-carousel]').forEach((carousel) => {
      const id = carousel.parentElement.id;
      if (!announcements[id]) return;
      announcements[id].unpausePlayer();
    });
  });
}
